import React from 'react';

import { PdfViewerProps } from './types';

export const PdfViewer: React.FC<PdfViewerProps> = ({ sourceUrl }) => {
  const src = sourceUrl;

  if (!src) {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#333',
          color: '#ccc',
        }}
      >
        PDF preview is unavailable.
      </div>
    );
  }

  return <iframe title="PDF" src={src} height="100%" width="100%" />;
};
